export default __webpack_public_path__ + "static/media/icon_bg_orange.248f3656.jpg";